import { FetchMethod, useCodeerApi } from "../useCodeerApi"
import { Response } from "@/types"

// ===== Slack API Response Types (snake_case to match backend) =====

export interface VerifySlackCredentialsResponse {
  team_id: string
  team_name: string
  bot_user_id: string
  bot_name?: string
}

export interface SlackWebhookUrlResponse {
  webhook_url: string
}

// ===== Slack API Request Types =====

export interface VerifySlackCredentialsRequest {
  bot_token: string
  signing_secret: string
}

// ===== Slack API Hooks =====

/**
 * Verify Slack bot credentials and get workspace info
 */
export const useVerifySlackCredentialsApi = () => {
  return useCodeerApi<
    Response<VerifySlackCredentialsResponse>,
    VerifySlackCredentialsRequest
  >("/slack/verify-credentials", FetchMethod.Post)
}

/**
 * Get the webhook URL for Slack Event Subscriptions (requires channel_id)
 */
export const useGetSlackWebhookUrlApi = () => {
  return useCodeerApi<Response<SlackWebhookUrlResponse>>(
    "/slack/webhook-url",
    FetchMethod.Get
  )
}
